import { calculate } from "specificity";
import { priorityByRule } from ".";

function calculateScore(rule, stackSize, property) {
  var score = +calculate(rule.selectorText)[0].specificity.replace(/,/g, "");
  var specificity = stackSize + score * 10 + priorityByRule(rule, property);
  return {
    selector: rule.selectorText,
    specificity: specificity
  };
}

export { calculateScore };